<h1 mat-dialog-title>{{ 'dialogs.changePassword.title' | translate }}</h1>

<mat-dialog-content class="mb-3">
  <div class="alert alert-info alert-dismissible" role="alert">
    {{ 'dialogs.changePassword.message' | translate }}
    <br>
    {{ 'dialogs.changePassword.message2' | translate }}
  </div> <!-- /.alert -->
  <div class="form-wrapper mt-3">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->

<mat-dialog-actions align="end">
  <a mat-raised-button [color]="data.btnCancelColor" (click)="onDenial()">
    <!-- class="close-btn" -->
    <mat-icon fontSet="fal" [fontIcon]="data.btnCancelIcon"></mat-icon>
    {{ 'common.cta.logout' | translate }}
  </a>
  <button mat-raised-button [color]="data.btnOkColor" (click)="onConfirmation()">
    <mat-icon fontSet="fal" [fontIcon]="data.btnOkIcon"></mat-icon>
    {{ 'dialogs.changePassword.btnOkText' | translate }}
  </button>
</mat-dialog-actions> <!-- /.mat-dialog-actions -->
